import type { ErrorHandler } from '@awazevr/mfe-common.contexts.tms'

import { CORRELATION_ID_COOKIE_NAME } from '@/constants'
import { getCookie } from '@/utils/helpers'

export const dataLayerErrorHandler: ErrorHandler = (
  error: Error,
  errorContextMessage: string,
  errorContextMetaData?: Record<string, unknown>,
) => {
  if (typeof newrelic !== 'undefined') {
    const correlationId = getCookie(CORRELATION_ID_COOKIE_NAME)
    newrelic.noticeError(error, {
      ...(correlationId && { correlationId }),
      errorContextMessage,
      ...errorContextMetaData,
    })
  }
}
